<template>
  <v-dialog v-model="rollBackPopUp" width="500" persistent>
    <v-card>
      <v-card-title class="card-title-div">
        <div style="display: flex; justify-content: space-between">
          <p style="margin-bottom: 0px;">Select Employee(s) for Rollback</p>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-actions>
        <div class="card-action-div">
          <div class="auto-div">
            <p style="margin-bottom: 0px;">Select Paygroup</p>
            <v-autocomplete 
              class="box-auto" 
              v-model="selectedPaygroup" 
              :items="paygroups" 
              :item-text="paygroupItemText"
              :item-value="paygroupItemValue" 
              hide-no-data 
              placeholder="Select Paygroup" 
              deletable-chips 
              clearable 
              return-object
            ></v-autocomplete>
          </div>
          <p style="margin-bottom: 0px;">Enter Employee Codes* :
            <span :class="{ 'bold-text': detailsLength == 0, 'light-text': detailsLength>0 }">
              (Min one Emp code to be added.)
            </span>
          </p>
          <textarea class="form-control custom-textarea margintop-16" 
                    rows="15" 
                    name="selectEmp" 
                    v-model="details" 
                    placeholder="Enter employee codes separated by comma ( , )"></textarea>
        </div>
      </v-card-actions>

      <v-divider class="divider"></v-divider>

      <v-card-actions class="card-button-div">
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="closeDialog" class="close-btn">Cancel</v-btn>
        <v-btn flat @click="handleNext" :disabled="this.details.length==0" class="next-btn">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    paygroups: {
      type: Array,
      default: () => [],
    },
    paygroupItemText: {
      type: String,
      default: "payGroupName",
    },
    paygroupItemValue: {
      type: String,
      default: "id",
    },
    selectedPaygroup: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rollBackPopUp: this.showDialog,
      details: "",
    };
  },
  computed: {
    detailsLength() {
      return this.details.length
    },
  },
  watch: {
    showDialog(val) {
      this.rollBackPopUp = val;
    },
    rollBackPopUp(val) {
      this.$emit("update:showDialog", val);
    },
  },
  methods: {
    closeDialog() {
      this.rollBackPopUp = false;
      this.$emit("close");
      this.details='';
      this. selectedPaygroup= {
      type: Object,
      default: null,
    };
    },
    handleNext() {
      let  data = {
        employeeCodes: (this.details.split(/[\s,]+/).filter(item => item !== '')).map(code => code.trim()),
        selectedPaygroup: this.selectedPaygroup,
      };
      this.$emit("next", data);
      this.details='';
      this. selectedPaygroup= {
      type: Object,
      default: null,
    };
      this.rollBackPopUp = false;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .box-auto .v-select__slot {
  border: #D0D0D0 solid 1px;
  border-radius: 5px;
}

::v-deep .form-control {
  width: 100%;
  min-height: 190px;
  max-height: auto;
}

::v-deep .v-select.v-text-field input {
  margin-left: 10px;
}

::v-deep .v-card__actions {
  display: block;
  padding: 24px;
}

::v-deep .box-auto .v-select.v-text-field input {
  margin: 0px 5px;
}
.card-title-div{
  color: #5D409F; 
  font-size: 16px; 
  font-weight: bold;
}
.card-action-div{
  display: flex; 
  flex-direction: column;
}
.auto-div{
  display: flex; 
  align-items: center; 
  gap: 20px;
}
.card-button-div{
  display: flex; 
  align-items: flex-end;
}
.close-btn{
  border: 1px solid #59419A; 
  padding: 20px 40px; 
  border-radius: 5px; 
  color: #59419A
}
.next-btn{
  border-radius: 5px; 
  padding: 20px 40px; 
  border-radius: 5px; 
  background-color: #5D409F; 
  color: #FFFFFF
}
::v-deep .v-dialog__content.v-dialog__content--active {
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
}
.bold-text {
  font-weight: bold;
  color: red; /* Make it bold and more noticeable when under 10 characters */
}
.light-text {
  font-weight: normal;
  color: lightgray; /* Make it light when 10 or more characters */
}
</style>